/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validPhone (str) {
  const patter = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/
  return patter.test(str) || str === '11111111111' || str === 'admin'
}



// WEBPACK FOOTER //
// ./src/utils/validate.js